import * as React from 'react';

import * as Schema from 'nutshell-core/schema';
import type {UnserializedFilterObject, EntityListType} from 'nutshell-core/types';

import {FormBadge} from './forms/badge';
import {FormBoolean} from './forms/boolean';
import {FormDateTime} from './forms/date-time';
import {FormInteger} from './forms/integer';
import {FormLocation} from './forms/location';
import {FormNumber} from './forms/number';
import {FormPhone} from './forms/phone';
import {FormState} from './forms/state';
import {FormString} from './forms/string';

const FILTER_COMPONENTS = {
    string: FormString,
    text: FormString,
    email: FormString,
    phone: FormPhone,
    integer: FormInteger,
    currency: FormNumber,
    'date-time': FormDateTime,
    'date-time-nullable': FormDateTime,
    'linked-lead-date': FormDateTime,
    boolean: FormBoolean,
    location: FormLocation,
    state: FormState,
    rating: FormInteger,
    badge: FormBadge,
} as const;

type Props = {
    field: Schema.FieldProperties;
    value?: any;
    entityType: EntityListType;
    excludedOptions?: string[];
    onChange: (formData: UnserializedFilterObject<any>) => void;
    onClearValue: () => void;
};

export class FilterForm extends React.PureComponent<Props> {
    render() {
        const type = this.props.field.type;
        // @ts-expect-error
        const isNumber = type === 'integer' || type === 'currency' || type === 'rating';

        // @ts-expect-error
        if (type === 'enum' || type === 'relationship' || type === 'stage') {
            // Should be using `MultipleFilter` for these types instead
            return null;
        }

        const FilterComponent = FILTER_COMPONENTS[type];

        return (
            <FilterComponent
                {...this.props.field}
                // @ts-expect-error
                entityType={this.props.entityType}
                value={this.props.value}
                excludedOptions={this.props.excludedOptions}
                onChange={this.props.onChange}
                onClearValue={this.props.onClearValue}
                isNumber={isNumber}
                // @ts-expect-error
                isSimple={Boolean(this.props.field.isSimple || false)}
            />
        );
    }
}
